export default "__VITE_ASSET__BITwSGWX__"